import React from 'react';

/**
 * 8x8 pixel icons drawn as crisp SVG rects in the current text color.
 * Replaces emoji, which render differently on every OS and break the pixel look.
 */
const ICONS = {
  bolt: [
    '....##..',
    '...##...',
    '..##....',
    '.######.',
    '....##..',
    '...##...',
    '..##....',
    '.##.....'
  ],
  target: [
    '..####..',
    '.#....#.',
    '#..##..#',
    '#.#..#.#',
    '#.#..#.#',
    '#..##..#',
    '.#....#.',
    '..####..'
  ],
  antenna: [
    '#.....#.',
    '.#...#..',
    '..#.#...',
    '...#....',
    '...#....',
    '...#....',
    '..###...',
    '.#####..'
  ],
  bars: [
    '........',
    '......##',
    '......##',
    '...##.##',
    '...##.##',
    '##.##.##',
    '##.##.##',
    '########'
  ],
  chart: [
    '#.......',
    '#......#',
    '#.....#.',
    '#.#..#..',
    '#.#.##..',
    '##.#....',
    '#.......',
    '########'
  ],
  doc: [
    '#####...',
    '#...##..',
    '#....##.',
    '#.###.#.',
    '#.....#.',
    '#.###.#.',
    '#.....#.',
    '#######.'
  ],
  warning: [
    '...##...',
    '...##...',
    '..#..#..',
    '..#..#..',
    '.#.##.#.',
    '.#....#.',
    '#..##..#',
    '########'
  ],
  scale: [
    '...##...',
    '########',
    '#..##..#',
    '#..##..#',
    '##.##.##',
    '...##...',
    '...##...',
    '.######.'
  ],
  sword: [
    '......##',
    '.....###',
    '....###.',
    '#..###..',
    '.####...',
    '..##....',
    '.#.#....',
    '#...#...'
  ],
  people: [
    '.##..##.',
    '.##..##.',
    '........',
    '###..###',
    '###..###',
    '###..###',
    '........',
    '........'
  ],
  clipboard: [
    '..####..',
    '##....##',
    '#.####.#',
    '#......#',
    '#.####.#',
    '#......#',
    '#.###..#',
    '########'
  ],
  coin: [
    '..####..',
    '.#.##.#.',
    '#.#....#',
    '#..##..#',
    '#....#.#',
    '#.###..#',
    '.#.##.#.',
    '..####..'
  ],
  chip: [
    '.#.#.#..',
    '########',
    '#......#',
    '#.####.#',
    '#.####.#',
    '#......#',
    '########',
    '.#.#.#..'
  ],
  link: [
    '....####',
    '......##',
    '.....#.#',
    '....#...',
    '#..#....',
    '#.......',
    '#.......',
    '#####...'
  ],
  robot: [
    '...##...',
    '########',
    '#......#',
    '#.#..#.#',
    '#......#',
    '#.####.#',
    '#......#',
    '########'
  ],
  close: [
    '#......#',
    '.#....#.',
    '..#..#..',
    '...##...',
    '...##...',
    '..#..#..',
    '.#....#.',
    '#......#'
  ]
};

// Merge horizontal runs into one rect each
function toRects(rows) {
  const rects = [];
  rows.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (row[x] === '#') {
        let w = 1;
        while (row[x + w] === '#') w++;
        rects.push({ x, y, w });
        x += w;
      } else {
        x++;
      }
    }
  });
  return rects;
}

const CACHE = Object.fromEntries(Object.entries(ICONS).map(([name, rows]) => [name, toRects(rows)]));

function PixelIcon({ name, size = 16, className = '', title }) {
  const rects = CACHE[name];
  if (!rects) return null;
  return (
    <svg
      className={`pixel-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      fill="currentColor"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {rects.map(({ x, y, w }) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={w} height={1} />
      ))}
    </svg>
  );
}

export default PixelIcon;
